module.exports = __webpack_public_path__ + "static/media/TN-Women-Earrings.b0b38aa5.svg";